<template>
  <div class="tourSummary">
    <div
      v-if="destination"
      class="tourSummary_row"
    >
      <tk-image
        :class="['tourSummary_icon', { '-border': iconBorder }]"
        :image-path="require('@ota-frontend/shared-assets/images/tour/ico_place.png')"
        alt="目的地"
      />
      <div :class="['tourSummary_description', `-${size}`]">{{ destinationText }}</div>
    </div>
    <div
      v-if="transportation"
      class="tourSummary_row"
    >
      <tk-image
        :class="['tourSummary_icon', { '-border': iconBorder }]"
        :image-path="transportationIcon"
        :alt="transportationAlt"
      />
      <!-- eslint-disable vue/no-v-html -->
      <div
        :class="['tourSummary_description', `-${size}`]"
        v-html="transportationText"
      />
      <!-- eslint-enable vue/no-v-html -->
    </div>
    <template v-if="hotels">
      <div
        v-for="hotelSchedule in hotelSchedules"
        :key="hotelSchedule[0].code"
        class="tourSummary_row"
      >
        <tk-image
          :class="['tourSummary_icon', { '-border': iconBorder }]"
          :image-path="require('@ota-frontend/shared-assets/images/tour/ico_hotel.png')"
          alt="ホテル"
        />
        <div :class="['tourSummary_description', `-${size}`]">
          {{ makeHotelText(hotelSchedule) }}{{ hotelsWithDestination ? ` (${destinationText})` : ''}}
          <tk-star-rating
            v-if="'rank' in hotelSchedule[0]"
            class="tourSummary_hotelRating"
            text-class="tourSummary_hotelRatingText"
            :star-number="hotelSchedule[0].rank"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { uniq } from 'lodash'
import { TkImage, TkStarRating } from '@ota-frontend/ui'

export default {
  components: { TkImage, TkStarRating },

  props: {
    tour: {
      type: Object,
      required: true,
    },
    hotelsWithDestination: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'normal',  // 'normal', 'large'
    },
    iconBorder: {
      type: Boolean,
      default: false,
    },
    destination: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    transportation: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    hotels: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    }
  },

  computed: {
    destinationText() {
      return uniq(
        this.tour.destinations
          .filter(d => !!d.city_name)
          .map(d => d.district_name
              ? `${d.city_name}(${d.district_name})`
              : d.city_name)
      ).join(',')
    },
    transportationIcon() {
      return this.tour.train
        ? require('@ota-frontend/shared-assets/images/tour/ico_train.png')
        : require('@ota-frontend/shared-assets/images/tour/ico_air.png')
    },
    transportationAlt() {
      return this.tour.domestic ? '交通機関' : '航空会社'
    },
    transportationText() {
      return this.tour.train ? this.tour.train.description : this.transportationAirText
    },
    transportationAirText() {
      switch (this.tour.air.condition) {
        case '0':
          return '未定'
        case '1':
          return `${this.airlineTexts.join(' ')} のいずれか${this.flightsTypeText}`
        default:
          return this.airlineTexts.map((text, i) =>
            i % 2 === 0 && i !== 0 ? `<br>${text}` : text
          ).join(' ') + (this.tour.air.condition === '2' ? ' 指定' : ' を全て利用') + this.flightsTypeText
      }
    },
    airlineTexts() {
      return this.tour.air.airlines.map(a => `${a.carrier_name}（${a.carrier_code}）`)
    },

    hotelSchedules() {
      return [
        ...this.tour.hotel.hotels.filter(hotel => [0, 3].includes(hotel.condition)).map(hotel => [hotel]),
        this.tour.hotel.hotels.filter(hotel => hotel.condition === 1),
        this.tour.hotel.hotels.filter(hotel => hotel.condition === 2),
      ].filter(hotelSchedule => hotelSchedule.length > 0)
    },
    flightsTypeText() {
      return this.tour.air.stopover === '0' ? '（直行便）' : '（乗継便）'
    },
  },

  methods: {
    makeHotelText(hotelSchedule) {
      switch (hotelSchedule[0].condition) {
        case 0: return `${hotelSchedule[0].name}と同等クラス`
        case 1: return `${hotelSchedule[0].name}等、計${hotelSchedule.length}ホテルのいずれか`
        case 2: return `${hotelSchedule[0].name}等、計${hotelSchedule.length}ホテルから選択`
        default: return `${hotelSchedule[0].name}指定`
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.tourSummary {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tourSummary_row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tourSummary_icon {
  align-self: start;
  width: 15px;
  height: 15px;

  &.-border {
    width: 25px;
    height: 25px;
    padding: 5px;
    border: solid 1px #d2d2d2;
    border-radius: 4px;
    box-sizing: border-box;
  }
}
.tourSummary_description {
  flex: 1;

  &.-normal {
    font-size: 11px;
  }
  &.-large {
    font-size: 14px;
  }
}
.tourSummary_hotelRating {
  display: inline-block;
}
</style>

<style lang="scss">
// tk-star-rating が外からスタイルを編集する仕様のため、これだけ scoped を外している
.tourSummary_hotelRatingText {
  display: none;
}
</style>
